'use client';

import {
  Box,
  BoxProps,
  HStack,
  IconButton,
  Spinner,
  SpinnerProps,
} from '@chakra-ui/react';

interface LoaderProps {
  size?: SpinnerProps['size'];
  height?: BoxProps['height'];
}

export function Loader({ size = 'xl', height = '70vh' }: LoaderProps) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      bg={'white'}
      width="full"
      height={height}
    >
      <Spinner size={size} bg={'white'} color="blackAlpha.700" />
    </Box>
  );
};

interface PageLoaderProps {
  text?: string;
  height?: BoxProps['height'];
}

export function PageLoader({ height = '70vh' }: PageLoaderProps) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      bg={'white'}
      width="full"
      height={height}
    >
      <HStack spacing="4" alignItems="center">
        <Spinner size="lg" color="blackAlpha.700" />
      </HStack>
    </Box>
  );
};

export const LoadingButton = () => {
  return (
    <HStack
      zIndex="1"
      left="50%"
      position="fixed"
      transform="translate(-50%, 0);"
      p={{ mobile: '4', desktop: '16' }}
      // What is this strange code?
      bottom={{ base: '0', sm: '85', md: '85', lg: '0' }}
    >
      <IconButton
        aria-label="Loading"
        icon={<Spinner size="sm" />}
      />
    </HStack>
  );
};
